import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { BreadcrumbService } from '../../ngx-admin-lte/services/breadcrumb.service';
import { FactureService } from '../../services/data/facture.service';
import { Facture } from '../../models/facture';
import { ClientService } from '../../services/data/client.service';
import { Client } from '../../models/client';
import { UserService } from '../../services/data/user.service';
import { User } from '../../models/user';
import { ProduitService } from '../../services/data/produit.service';
import { Produit } from '../../models/produit';
import { AchatService } from '../../services/data/achat.service';
import { Achat } from '../../models/achat';
import { PrestationService } from '../../services/data/prestation.service';
import { Prestation } from '../../models/prestation';
import { of } from 'rxjs';
import { Categorie } from 'src/app/models/categorie';
import { CategorieService } from 'src/app/services/data/categorie.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  public date: Date = new Date();
  public facture: Facture = null;

  private etapesValides: any = [
    {
      ordre: 0,
      valid: false
    },
    {
      ordre: 1,
      valid: false
    },
    {
      ordre: 2,
      valid: false
    },
    {
      ordre: 3,
      valid: false
    }
  ];

  public env_name = environment.name;

  public current_step = 0;

  public client: Client = null; // le client en cours pour la facture
  public liste_clients: Array<Client> = null;
  public saved_client_state:string = '';

  public user: User = null; // le client en cours pour la facture
  public liste_users: Array<User> = null;

  public produit: Produit = null; // le produit en cours d'ajout
  public liste_produits: Array<Produit> = null; // liste des produits disponibles

  public prestation: Prestation= null; // le prestation en cours d'ajout
  public liste_prestations: Array<Prestation> = null; // liste des prestations disponibles

// les achats séléctionnées
  public achat: Achat = null; // le produit en cours d'ajout
  public liste_achats: Array<Achat> = null; // liste des achats fait (= panier)

  public liste_categories: Array<Categorie> = [];
  public selected_type_of_categ: String = null;
  public selected_categorie: Categorie = null;
  public selected_size: String = null;

  public cash_selected = false;
  public check_selected = false;
  public cash = 0;
  public a_rendre = 0;
  public saved_pct = 0;

  public nb_facture_coif = {};

  public client_can_have_reduction = false;
  private use_reduc = true; // utilisation de la reduc si dispo
  private id = 0; // id de client si on vient par une route de client

  constructor(
    private _bread_serv: BreadcrumbService,
    private _client_serv: ClientService,
    private _user_serv: UserService,
    private _produit_serv: ProduitService,
    private _presta_serv: PrestationService,
    private _facture_serv: FactureService,
    private _categorie_serv: CategorieService,
    private _achat_serv: AchatService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _sanitizer: DomSanitizer
  ) {
    this._bread_serv.setCurrent([{
      label: environment.name,
      link: '/',
      icon: 'dashboard'
    }, {
      label: 'Nouvelle facture',
      link: '/',
      icon: 'dollar'
    }]);
  }

  ngOnInit() {

    // recuperation des parametres de route
    this._route.params.forEach((params: Params) => {
      this.id = +params['id'];
      this.initClient();
    });

    // initialisation de la facture
    this.facture = new Facture();
    this.facture.date = Math.floor( Date.now() / 1000 );
    // this.facture.realise_par_user_id = this.user.id;
    // this.facture.facture_par_user_id = this.user.id;

    this.liste_achats = [];

    // recuperation des coiffeuses
    this._user_serv.getAll().subscribe((list) => {
      this.liste_users = list;
      //recuperation de leur nombre de facture deja fait
      this.liste_users.forEach((coif) => {
        this.getFacture(coif).subscribe((factures) => {
          this.nb_facture_coif[coif.id] = factures;
        })
      })
    });

    // recuperation des categories
    this._categorie_serv.getAll().subscribe((list) => {
      this.liste_categories = list;
    });

    // recuperation des clients et tri
    this._client_serv.getAll().subscribe((list) => {

      this.liste_clients = list.sort((a, b) => {
        if ( a.nom < b.nom) {
          return -1;
        } else if ( a.nom > b.nom) {
          return 1;
        } else if ( a.prenom < b.prenom ) {
          return -1;
        } else if ( a.prenom > b.prenom ) {
          return 1;
        } else {
          return 0;
        }
      });

      this.initClient();

    });

    // recuperation des produits et tri
    this._produit_serv.getAll().subscribe((list) => {
      this.liste_produits = list.sort((a, b) => {
        if ( a.nom < b.nom) {
          return -1;
        } else if ( a.nom > b.nom) {
          return 1;
        } else {
          return 0;
        }
      });
    });

    // recuperation des produits et tri
    this._presta_serv.getAll().subscribe((list) => {
      this.liste_prestations = list.sort((a, b) => {
        if ( a.nom < b.nom) {
          return -1;
        } else if ( a.nom > b.nom) {
          return 1;
        } else {
          return 0;
        }
      });
    });


  }

  ngOnDestroy() {
    this._bread_serv.clear();
  }

  public getClientFullname(client: Client) {
    if(client){
      return client.nom.toUpperCase() + ' ' + client.prenom;
    }else
      return ""
  }

  public getAvatar(user){
    if(user && user.avatar_url !== null && user.avatar_url.length > 1){
      return user.avatar_url;
    }
    else{
      return 'assets/ciseaux.png';
    }
  }

  public getHeader(user){
    if(user && user.header_url !== null && user.header_url.length > 0){
      return {
        class: "widget-user-header bg-black",
        style: this._sanitizer.bypassSecurityTrustStyle("background: url('"+user.header_url+"') center center;")
     }
    }
    else{
      return { class :"widget-user-header bg-aqua-active", style: "" }
    }
  }

  public getFacture(user){
    if(user && user.id){
      return this._facture_serv.getRealiseParUser(user.id)
    }
    return of([]);
  }

  public onSelectClient(client){
    this.client = client;

    if( this.calcReduction() > 0){
      this.client_can_have_reduction = true;
    }
  }

  public onSelectUser(coif){
    this.user = coif;
    this.changeValidOfStep(0,true);
    this.setCurrentToFirstStepNotTrue();
  }

  public onSelectPres(p){
    this.prestation = p;
  }

  public onSelectProd(p){
    this.produit = p;
  }

  public getFiltredPrestations(categ: Categorie): Array<Prestation>{
    //filtre par categorie
    let reste = this.liste_prestations.filter((p) => {
      return p.categorie_id+'' === categ.id+'';
    });
    //si on a choisie une taille on filtre
    if(this.selected_size !== null){
      reste = reste.filter((p) => {
        return p.taille === this.selected_size;
      });
    }
    return reste;
  }

  public getCategorieOfType(type: String): Array<Categorie>{
    return this.liste_categories.filter((c) => {
      return c.type === type;
    });
  }

  initClient() {
    console.log('client init', this.id, this.client);
    if (this.id > 0 && !this.client) {
      this.client = this._client_serv.getFromCache(this.id);
    }
  }

  // STEP 1 : choix du client

  validerStep(step){
    this.changeValidOfStep(step,true);
    this.setCurrentToFirstStepNotTrue();
  }

  create(){
    this._router.navigate(['/client/'+0]);
    return false;
  }

  clientAnonyme(){
    // init avec client anonyme
    this.client = new Client({
      id: 0,
      nom: 'ANONYME',
      prenom: ''
    });
    this.validerStep(1);
  }

  saveClient(client:Client){
    this.saved_client_state = 'en cours...';
    if(client.id > 0){
      this._client_serv.update(client.id,client).subscribe((retour) => {
        //go back to list
        this.saved_client_state = 'ok';
      });
    }
  }

  // STEP 2 : choix des produits et prestation
  ajouterPrestaById(pid){
    let presta = this.getPresta(pid);
    return this.ajouterPresta(presta);
  }

  ajouterPresta(presta){
    console.log(presta);
    let achat: Achat = this.getAchatByPresta(presta);
    // on verifie s'il y a deja un achat de cette prestation sinon on en crée un nouveau
    if(!achat){
      achat = new Achat({
        prestation_id: presta.id,
        quantite: 1,
        montant_unitaire: presta.tarif
      });
      this.liste_achats.push(achat);
    }
    // si oui, on ajoute a la quantité
    else{
      achat.quantite++;
    }
    //on re init les categories
    this.selected_categorie = null;
    this.selected_type_of_categ = null;
    this.selected_size = null;
  }

  ajouterProduitById(pid){
    let produit = this.getProduit(pid);
    return this.ajouterProduit(produit);
  }

  ajouterProduit(produit){;
    let achat: Achat = this.getAchatByProduit(produit);
    // on verifie s'il y a deja un achat de ce produit sinon on en crée un nouveau
    if(!achat){
      achat = new Achat({
        produit_id: produit.id,
        quantite: 1,
        montant_unitaire: produit.tarif
      });
      this.liste_achats.push(achat);
    }
    // si oui, on ajoute a la quantité
    else{
      achat.quantite++;
    }
  }

  retirerProduitById(id){
    let produit = this.getProduit(id);
    return this.retirerProduit(produit);
  }

  retirerProduit(produit){
    let achat: Achat = this.getAchatByProduit(produit);
    // on verifie s'il y a deja un achat de ce produit, si oui, on le decremente
    if(achat){
      achat.quantite--;
      // si y'a plus de quantité on supprime l'achat
      if(achat.quantite <= 0){
        this.liste_achats = this.liste_achats.filter((unit) => unit !== achat);
      }
    }
  }

  retirerPrestaById(id){
    let presta = this.getPresta(id);
    return this.retirerPresta(presta);
  }

  retirerPresta(presta){
    console.log(presta)
    let achat: Achat = this.getAchatByPresta(presta);
    // on verifie s'il y a deja un achat de ce produit, si oui, on le decremente
    if(achat){
      achat.quantite--;
      // si y'a plus de quantité on supprime l'achat
      if(achat.quantite <= 0){
        this.liste_achats = this.liste_achats.filter((unit) => unit !== achat);
      }
    }
  }

  getTotalPrice(achat){
    let p = null;
    if(achat.prestation_id > 0){
      p = this.getPresta(achat.prestation_id);
    }
    else if(achat.produit_id > 0){
      p = this.getProduit(achat.produit_id);
    }
    return parseFloat(p.tarif.replace(',','.')) * parseInt(achat.quantite);
  }

  getProduit(id): Produit{
    return this.liste_produits.find((unit) => unit.id === id);
  }
  getAchatByProduit( produit: Produit): Achat{
    return this.liste_achats.find((unit: Achat) => unit.produit_id === produit.id);
  }

  getPresta(id): Prestation{
    return this.liste_prestations.find((unit) => unit.id === id);
  }
  getAchatByPresta( presta: Prestation): Achat{
    return this.liste_achats.find((unit: Achat) => unit.prestation_id === presta.id);
  }

  getListePresta(){
    return this.liste_achats.filter((unit) => { return unit.prestation_id > 0});
  }

  getListeProduit(){
    return this.liste_achats.filter((unit) => { return unit.produit_id > 0});
  }

  validerStep2(){
    this.validerStep(2);
    this.facture.montant_total = this.calcTotal() + '';
  }

  goBackToStep(step){
    console.log("Retour vers l'étape "+step);
    this.changeValidOfStep(step,false);
    this.setCurrentToFirstStepNotTrue();
  }

  changeValidOfStep(num_step,value){
    this.etapesValides = this.etapesValides.map((step) => {
      if(num_step === step.ordre){
        step.valid = value;
      }
      return step;
    });
  }

  // STEP 3
  toRealNumber(num){
    return (Math.floor(num*100))/100;
  }

  totalDesAchats(){
    let total:number = 0;
    this.liste_achats.forEach((achat: Achat) => {
      total += this.getTotalPrice(achat);
    });
    return total;
  }

  calcTotal(){
    return this.toRealNumber(this.totalDesAchats() - this.calcReduction());
  }

  calcReduction() {
    // test si le client a le droit a une reduction
    let reduc = 0;
    if( this.client.tampon === 20 && this.use_reduc ){
      reduc = (this.totalDesAchats() * 0.20);
    }
    else if( this.client.tampon >= 10 && !this.client.last_tampon_used && this.use_reduc ){
      reduc = (this.totalDesAchats() * 0.10);
    }
    else if( this.client.tampon >= 5 && !this.client.last_tampon_used && this.use_reduc ){
      reduc = (this.totalDesAchats() * 0.05);
    }
    return reduc;
  }

  noReduction() {
    this.use_reduc = false;
    this.facture.montant_total = this.calcTotal() + '';
  }

  useReduction() {
    this.use_reduc = true;
    this.facture.montant_total = this.calcTotal() + '';
  }

  //aprés l'achat on calcule le nouvel etat du client avec ses tampons
  calcNewTamponState(){
    let used = this.calcReduction() > 0;
    //si le client a utilise une reduc de 5 ou 10%
    if(used && this.client.tampon < 20 && this.client.tampon > 5){
      this.client.last_tampon_used = true;
    }

    //ensuite on augmente le nombre de tampon
    this.client.tampon++;

    //puis si on passe tout pile un palier, on re-init le last
    if( ([5,10,20]).indexOf(this.client.tampon) !== -1 ){
      this.client.last_tampon_used = false;
    }
    //si on est passé au dessus de la limite on repars à zero (et utilisé la reduc)
    if(used && this.client.tampon > 20){
      this.client.tampon = 0;
    }
  }

  paiementCash() {
    this.cash_selected = true;
  }

  paiementCheck(){
    this.check_selected = true;
  }

  cancelPaiement(){
    this.cash_selected = false;
    this.check_selected = false;
  }


  setCurrentToFirstStepNotTrue(){
    let mini: number = 0;
    for(let i = 0; i < this.etapesValides.length; i++){
      let step = this.etapesValides[i];
      if( !step.valid && (mini === 0 || step.ordre < mini) ){
        mini = step.ordre;
        break;
      }
    }
    this.current_step = mini;
  }

  saveFacture(){

    if( !this.cash_selected && !this.check_selected){
      alert("Veuillez choisir un mode de paiement avant d'enregistrer");
      return false
    }

    //si anonyme
    if(this.client.id === 0){
      this.facture.client_id = null
    }
    else{
      this.facture.client_id = parseInt( this.client.id + '', 10);
    }

    this.facture.facture_par_user_id = parseInt(this.user.id+ '', 10);
    this.facture.realise_par_user_id = parseInt(this.user.id+ '', 10);
    this.facture.date = this.date.getTime();

    if(this.cash_selected){
      this.facture.paiement_id = 1;
    }
    else if(this.check_selected){
      this.facture.paiement_id = 2;
    }
    console.log(this.facture);

    this._facture_serv.add(this.facture).subscribe((id)=>{
      //on se mets en success
      this.validerStep(3);
      this.saved_pct = 50;
      // une fois qu'on a l'id de la facture, on le mets dans chaque achat
      this.liste_achats.forEach((element,index,arr)=>{
        element.facture_id = id;
      });
      // puis on les sauvegardes
      this._achat_serv.addAll(this.liste_achats).subscribe((data)=>{
        console.log("Les achats sont bien sauvegardés");
        this.saved_pct += 25;
      });
      this.calcNewTamponState();
      this._client_serv.update(this.client.id,this.client).subscribe((data)=>{
        console.log("Le client a son nouveau compte de tampon");
        this.saved_pct += 25;
      });



    });

  }

}
